// noinspection DuplicatedCode

import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";

import {alertService} from "../../../services/AlertService";

import TableCard from "../../../components/tablecard/TableCard";
import ModalForm from "../../../components/modal/form/ModalForm";

import {areaRentalSelector, getAreaRental, insertAreaRental, updateAreaRental,} from "./areaRentalSlice";

import {Colors} from "../../../assets/Colors";

const AreaRentalPage = ({}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [firstLoading, setFirstLoading] = useState(false);
    const [start, setStart] = useState(0);
    const [count, setCount] = useState(5);
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(0);
    const [search, setSearch] = useState("");
    const [searchFetch, setSearchFetch] = useState(false);
    const [insertFetch, setInsertFetch] = useState(false);
    const [updateFetch, setUpdateFetch] = useState(false);
    const [showModalAdd, setShowModalAdd] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [currentData, setCurrentData] = useState({});

    const areaRental = useSelector(areaRentalSelector);

    useEffect(() => {
        dispatch(
            getAreaRental({
                start: start,
                count: count,
                search: "",
            })
        );
    }, []);

    useEffect(() => {
        if (search !== "" && areaRental.isGetSuccess && !areaRental.isGetFetching) {
            let calc = areaRental?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if (calc % count === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = areaRental.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        } else if (
            search === "" &&
            areaRental.isGetSuccess &&
            !areaRental.isGetFetching
        ) {
            let calc = areaRental?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if (calc % count === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = areaRental.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        }

        if (
            !areaRental?.isGetFetching &&
            areaRental.isGetSuccess &&
            maxPage === 0 &&
            firstLoading === false
        ) {
            let calc = areaRental?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if (calc % count === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = areaRental.data ? Math.ceil(calc / count) : 1;
            setMaxPage(tempMaxPage);
            setFirstLoading(true);
            dispatch(
                getAreaRental({
                    start: start,
                    count: count,
                    search: search,
                })
            );
        }

        if (insertFetch) {
            setInsertFetch(false);
            if (areaRental.isGetSuccess) {
                alertService.success(areaRental.message, {
                    autoClose: true,
                    keepAfterRouteChange: false,
                });
                dispatch(
                    getAreaRental({
                        start: start,
                        count: count,
                        search: search,
                    })
                );
            }
        }

        if (updateFetch) {
            setUpdateFetch(false);
            if (areaRental.isUpdateSuccess) {
                alertService.success(areaRental.message, {
                    autoClose: true,
                    keepAfterRouteChange: false,
                });
                dispatch(
                    updateAreaRental({
                        start: start,
                        count: count,
                        search: search,
                    })
                );
            }
        }
    });

    // function handleGetAreaRental(params) {
    //   return dispatch(getAreaRental(params));
    // }

    function handleInsertAreaRental(param) {
        setInsertFetch(true);
        const params = {
            AreaRentalName: param.inputOneValue,
            CategoryID: param.dropDownAreaRentalValue,

        };

        dispatch(insertAreaRental(params));
    }

    function handleUpdateAreaRental(param) {
        setUpdateFetch(true);

        const params = {
            AreaRentalName: param.inputOneValue,
            AreaRentalID: currentData.AreaRentalID,
            CategoryID: param.dropDownAreaRentalValue,

            status: param.status,
        };
        dispatch(updateAreaRental(params));
    }

    function handleSearch(searchValue) {
        let params = {
            start: 0,
            count: 5,
            search: searchValue,
        };
        dispatch(getAreaRental(params));

        setStart(0);
        setCount(5);
        setSearch(searchValue);
        setSearchFetch(true);
    }

    function handleUpdatePage(newPage) {
        let newStart = newPage * count - count;

        let params = {
            start: newStart,
            count: count,
            search: search,
        };
        dispatch(getAreaRental(params));

        setPage(newPage);
        setStart(newStart);
    }

    function handleUpdateCount(newCount) {
        let calc = areaRental.count - 1;
        if (calc === 0) {
            calc = 1;
        }

        let params = {
            start: newCount === "-1" ? 0 : start,
            count: newCount === "-1" ? areaRental.count : newCount,
            search: search,
        };
        dispatch(getAreaRental(params));

        setPage(1);
        setCount(newCount === "-1" ? areaRental.count : newCount);
        setStart(newCount === "-1" ? 0 : start);
        setMaxPage(newCount === "-1" ? 1 : Math.ceil(calc / newCount));
    }

    function handleCurrentData(values) {
        setCurrentData(values);
    }

    function handleModal(status) {
        setShowModalAdd(status.showModalAdd);
        setShowModalEdit(status.showModalEdit);
    }

    if (!firstLoading) {
        return <div>loading</div>;
    } else {
        return (
            <div className="md:ml-64">
                <div
                    style={{background: Colors.primary}}
                    className="pt-14 pb-16 px-3 md:px-8 h-auto"
                >
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
                    </div>
                </div>
                <div className="px-3 md:px-8 h-auto -mt-32">
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 px-4">
                            <TableCard
                                backButton={true}
                                backUrl={"master"}
                                handleSearch={handleSearch}
                                searchPlaceholder="Area Rental"
                                updatePage={handleUpdatePage}
                                updateCount={handleUpdateCount}
                                currentData={handleCurrentData}
                                currentPage={page}
                                maxPage={maxPage}
                                tableTitle="Master Area Rental"
                                tableData={areaRental.data}
                                colOneTitle="ID"
                                colOneData="AreaRentalID"
                                colTwoTitle="Nama Area Rental"
                                colTwoData="AreaRentalName"
                                colThreeTitle="Kelompok"
                                colThreeData="CategoryName"
                                status="Status"
                                fetching={areaRental.isGetFetching}
                                modal={handleModal}
                                editEnabled={true}
                            />
                        </div>
                    </div>
                </div>
                {showModalAdd && (
                    <ModalForm
                        dropDownAreaRental={true}
                        showModal={showModalAdd}
                        addEnabled={true}
                        modal={handleModal}
                        modalTitle="Tambah Area Rental"
                        inputOneTitle="Nama Area Rental"
                        inputOneValue=""
                        submitButtonTitle="Submit"
                        dropDownAreaRentalValue=""
                        handleSubmit={handleInsertAreaRental}
                    />
                )}
                {showModalEdit && (
                    <ModalForm
                        dropDownAreaRental={true}
                        showModal={showModalEdit}
                        editEnabled={true}
                        id={currentData.AreaRentalID}
                        modal={handleModal}
                        modalTitle="Ubah Area Rental"
                        inputOneTitle="Nama Area Rental"
                        inputOneValue={currentData.AreaRentalName}
                        status={currentData.Status}
                        submitButtonTitle="Submit"
                        dropDownAreaRentalValue={currentData.CategoryID}
                        handleSubmit={handleUpdateAreaRental}
                    />
                )}
            </div>
        );
    }
};

export default AreaRentalPage;
